import React from 'react';
import Badge from 'react-bootstrap/Badge';
import { useTranslation } from 'react-i18next';
import { FaChartLine } from 'react-icons/fa';

import { uiHelpers } from '../../helpers';
import { HKStockItem, USStockItem } from '../../helpers/table.helper';
import { useAllTagEvaluations, useTags } from '../../helpers/tag.helpper';
import { useFavStocks } from '../../hooks/useFavoriteStocks';
import useLookupPageStockRegion from '../../hooks/useLookupPageStockRegion';
import { useMediaQuery } from '../../hooks/useMediaQuery';
import { regionToCategory } from '../stock/stockCategory';

interface Props {
  value: HKStockItem | USStockItem;
}

const StockCodeSpan: React.FC<Props> = ({ value }) => {
  const { i18n } = useTranslation();
  const { stocks: favStocks } = useFavStocks();
  const region = useLookupPageStockRegion(value.region);

  const tags = useTags();
  const allTagEvaluations = useAllTagEvaluations();

  const liked =
    favStocks && favStocks.map(s => s.ticker).includes(value.stockCode);

  const notMobile = useMediaQuery('(min-width: 768px)');

  const matchTags = tags.filter(tag => {
    const evalFn = allTagEvaluations[tag.id];
    if (!evalFn) {
      return false; // this should not happen
    }
    return evalFn(regionToCategory(region) + '#' + value.stockCode);
  });

  return (
    <span
      style={{
        color: liked ? '#aa0000' : 'black',
        display: 'flex',
        // change the stockcode column to two line in mobile
        flexDirection: notMobile ? 'unset' : 'column',
        fontWeight: notMobile ? 'unset' : 'bold',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <u
          style={{
            fontSize: notMobile ? '12px' : '16px',
          }}
        >
          {value.stockCode.startsWith('0')
            ? value.stockCode.slice(1) // only show first 4 digits for hk stocks
            : value.stockCode}
        </u>{' '}
        <div
          style={{
            display: 'flex',
            marginLeft: notMobile ? 3 : 5,
            fontSize: '12px',
          }}
        >
          <FaChartLine />
        </div>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <small>
            {region === 'us'
              ? uiHelpers.tradChify(value[`name_${i18n.language}`])
              : value[`name_${i18n.language}`]}
          </small>
        </div>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            marginLeft: notMobile ? 3 : 5,
            marginRight: 5,
          }}
        >
          {matchTags.map(tag => (
            <Badge key={tag.id} bg="secondary" style={{ marginRight: '2px' }}>
              {tag[`short_${i18n.language}`]}
            </Badge>
          ))}
        </div>
      </div>
    </span>
  );
};

export default StockCodeSpan;
